import { render, staticRenderFns } from "./SwitchSchoolModal.vue?vue&type=template&id=134209c4&"
import script from "./SwitchSchoolModal.vue?vue&type=script&lang=js&"
export * from "./SwitchSchoolModal.vue?vue&type=script&lang=js&"
import style0 from "./SwitchSchoolModal.vue?vue&type=style&index=0&id=134209c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports